<template>
  <div @click.stop>
    <ActionButton
      :link="'https://skr.de/+' + params.data.reise.reisekuerzel"
      title="Reisewiki"
      iconClass="fab fa-wikipedia-w"
    />
    <ActionButton
      :link="{ name: 'reisetermine-view', params: { reiseterminId: params.data.id } }"
      title="Reisetermin Detailansicht"
      iconClass="fas fa-info"
    />
    <ActionButton
      :link="
        'https://www.skr.de/reiseinfos/' +
        params.data.reiseterminkuerzel.replaceAll('-', '').replaceAll('_', '') +
        '/L/'
      "
      title="Reiseunterlagen"
      iconClass="flaticon-book text-black"
    />
    <ActionButton @click="createAufgabe" title="Aufgabe erstellen" :icon="ListChecks" />
  </div>
</template>

<script>
import { ListChecks } from 'lucide-vue';
import ActionButton from '@/components/common/action-button.vue';

export default {
  components: { ActionButton },
  data() {
    return { ListChecks };
  },
  methods: {
    createAufgabe() {
      const prefixedVerlinkungen = [
        {
          id: 0,
          typ: 'Reisetermin',
          artifactId: this.params.data.id,
          artifactText: this.params.data.reiseterminkuerzel,
        },
      ];
      this.params.onShowModalAufgabeEdit(prefixedVerlinkungen);
    },
  },
};
</script>

<style lang="scss" scoped></style>
